module.exports = __webpack_public_path__ + "img/customer-first.2af2ae39.png";